import React from 'react'
import { FieldProps } from 'formik'
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { useErrorStyle } from 'componentsHsc'

export interface Option {
  label: string
  value: string
}

interface Props extends FieldProps {
  optionList: Option[]
  className?: string
  row?: boolean
  disabled?: boolean
  myChange: Function
  checked: boolean
  formName?: string
  target?: string
}

const Toggle = ({
  field,
  form,
  optionList,
  className,
  row,
  disabled,
  myChange,
  checked,
  formName,
  target,
}: Props) => {
  const classes = useErrorStyle()
  const { errors, touched } = form
  const { name } = field
  const value = field.value || '0'

  const handleChange = (e: any) => {
    switch (target) {
      case 'questionCondition':
        form.setFieldValue('typeCode', e.target.value)
        form.setFieldValue('typeName', e.target.name)
        break
      case 'answerCondition':
        form.setFieldValue(formName + 'answerConditionFlag', e.target.value)
        form.setFieldValue(formName + 'answerConditionName', e.target.name)
        break
      case 'managementCondition':
        form.setFieldValue('typeCode', e.target.value)
        form.setFieldValue('typeName', e.target.name)
        break
      case 'managementItemPresence':
        form.setFieldValue(
          formName + 'managementItemPresenceFlag',
          e.target.value
        )
        form.setFieldValue(
          formName + 'managementItemPresenceName',
          e.target.name
        )
        break
      default:
        form.setFieldValue(name, e.target.value)
        break
    }
  }

  return (
    <FormControl
      error={Boolean(errors[name] && touched[name])}
      className={className}>
      <RadioGroup row={row} value={value} onChange={handleChange}>
        {optionList.map(i => (
          <FormControlLabel
            key={i.value}
            control={
              <Radio
                color='primary'
                value={i.value}
                disabled={disabled}
                checked={checked}
                name={i.label}
              />
            }
            label={i.label}
          />
        ))}
      </RadioGroup>
      {errors[name] && touched[name] ? (
        <p className={classes.helperText}>{errors[name]}</p>
      ) : null}
    </FormControl>
  )
}

export default Toggle
